import util from '@/util';
import uploadService from '../../../request/service/fileupload-service';
export default {
    setImgCover(color, item){
        let isEmptyVal = !color || color.trim() === '';
        if(isEmptyVal && !item.coverObj){
            return;
        }
        if(isEmptyVal && item.coverObj){
            this.setCoverUrl('');
            return;
        }
        let isColor = util.getRGBANumArray(color);
        if(isColor === null){
            return;
        }
        let {width, height, url} = item;
        let maxArea = 4000 * 4000; //暂时设置4000的最大高宽值，以免js遍历canvas data内存溢出
        if(width * height > maxArea){
            this.setCoverColor(color, item);
        }else{
            this.getCoverUrl(color, url, item).then((newUrl) => {
                this.setCoverUrl(newUrl, item, color);
            });
        }

    },
    setCoverColor(color, item){
        item.coverObj = !item.coverObj ? {} : item.coverObj
        item.coverObj.color = color;
        item.coverObj.url = null;
        item.key = util.getUUID();
    },
    setCoverUrl(url, item, color){
        if(!url && item.coverObj){
            item.coverObj = null;
            return;
        }
        item.coverObj = !item.coverObj ? {} : item.coverObj;
        Object.assign(item.coverObj, {url: url, colorBackup: color});
        item.key = util.getUUID();
    },
    getCoverUrl(color, url, item){
        return new Promise((resolve, reject) => {
            let colorArray = util.getRGBANumArray(color);
            if(colorArray.length === 3){
                colorArray.push(255);
            }
            if(colorArray[3] <= 1){
                colorArray[3] = 255 * colorArray[3];
            }
            let img = new Image();
            img.src = url + '?v=' + new Date().getTime();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext("2d");
                let width = img.width, height = img.height;
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0);
                let imgData = ctx.getImageData(0, 0, width, height);
                let a;
                for (let i = 0; i < imgData.data.length; i += 4) {
                    a = imgData.data[i + 3];
                    if (a > 100) {
                        imgData.data[i] = +colorArray[0];
                        imgData.data[i + 1] = +colorArray[1];
                        imgData.data[i + 2] = +colorArray[2];
                        imgData.data[i + 3] = +colorArray[3];
                    }
                }
                ctx.putImageData(imgData,0,0);
                uploadService.uploadFileByBase64(canvas.toDataURL()).then(({url}) => {
                    resolve(url);
                }).catch(() => {
                    reject();
                })
            }
        });
    }
}